module.exports = __webpack_public_path__ + "static/media/combined-degrees.71dc9f07.jpg";